import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'keyvalue',
  pure: false
})
export class KeyvaluePipe implements PipeTransform {

  private preValue;
  private returnValue;
  constructor() {

  }

  transform(value: any): any {
    if (this.preValue != value) {
      this.preValue = value;
      let keys = [];
      for (let key in value) {
        keys.push({ key: key, value: value[key] });
      }
      this.returnValue = keys;
    }
    return this.returnValue;
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/keyvalue/keyvalue.pipe.ts